import { render, staticRenderFns } from "./PortfolioManager.vue?vue&type=template&id=4270aada&scoped=true&"
import script from "./PortfolioManager.vue?vue&type=script&lang=js&"
export * from "./PortfolioManager.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioManager.vue?vue&type=style&index=0&id=4270aada&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4270aada",
  null
  
)

export default component.exports